/**
 * @note
 * This is the full list of menu items for both menu and desktop.
 *
 * Set either `mobileOnly` or `desktopOnly` to `true` to make it exclusive
 * to either one category (tablet devices are considered mobile). You can
 * also apply this to submenu items.
 *
 */
export const MENU_ITEMS = [
	{
		label: "Home",
		link: "/",
		icon: "home",
		isNew: false,
		mobileOnly: true,
		useRouter: true,
	},
	{
		label: "Words With Friends <span class='sub-label'>Cheat</span>",
		link: "/words-with-friends-cheat/",
		title: "Words With Friends Cheat",
		icon: "wwf",
		isNew: false,
		useRouter: true,
	},
	{
		label: "NYT Crossplay Cheat",
		link: "/nyt-crossplay/",
		title: "NYT Crossplay Cheat",
		icon: "c",
		mobileOnly: true,
		useRouter: true,
	},
	{
		label: "Scrabble <span class='sub-label'>Helpers</span>",
		link: null,
		title: "Scrabble Helpers",
		icon: "scrabble",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Scrabble Helpers",
				desktopOnly: true,
				sectionEntries: [
					{
						label: "Scrabble Word Checker",
						link: "/scrabble-dictionary/",
					},
					{
						label: "Scrabble Cheat",
						link: "/scrabble-cheat/",
					},
					{
						label: "Scrabble Word Finder",
						link: "/",
					},
					{
						label: "Scrabble Go Checker",
						link: "/scrabble-checker/",
					},
				],
			},
		],
	},
	{
		label: "Today's NYT Games <span class='sub-label'>Hints & Answers</span>",
		link: null,
		title: "Today's NYT Games Hints & Answers",
		icon: "calendar",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Wordle",
				sectionEntries: [
					{
						label: "Wordle Solver",
						link: "/wordle/",
						isHot: true,
					},
					{
						label: "Today's Wordle Hints & Answer",
						link: "/wordle/hints/",
					},
					{
						label: "List of Wordle Answers",
						link: "/wordle/answers/",
					},
					{
						label: "Wordle Word Lists",
						link: "/wordle/word-lists/",
					},
					{
						label: "Yesterday's Wordle Hints & Answer",
						link: "/wordle/yesterday-hints/",
					},
				],
			},
			{
				sectionName: "Today's NYT Connections",
				sectionEntries: [
					{
						label: "NYT Connections Hints",
						link: "/nyt-connections/",
					},
					{
						label: "NYT Connections Answers",
						link: "/nyt-connections/todays-answers/",
					},
					{
						label: "Yesterday's NYT Connections Hints & Answer",
						link: "/nyt-connections/yesterday-hints/",
					},
				],
			},
			{
				sectionName: "Today’s NYT Daily Games",
				sectionEntries: [
					{
						label: "NYT Crosswords Clues & Answers",
						link: "/crosswords/new-york-times-crossword/",
					},
					{
						label: "NYT Strands Hints & Answer",
						link: "/nyt-strands/",
					},
					{
						label: "NYT Spelling Bee Answers",
						link: "/nyt-spelling-bee/",
					},
					{
						label: "NYT Crossplay Dictionary",
						link: "/nyt-crossplay-dictionary/",
						isNew: true,
						mobileOnly: true,
					},
					{
						label: "NYT Crossplay Cheat",
						link: "/nyt-crossplay/",
						desktopOnly: true,
					},
					{
						label: "NYT Crossplay Dictionary",
						link: "/nyt-crossplay-dictionary/",
						isNew: true,
						desktopOnly: true,
					},
					{
						label: "All NYT Daily Games Helpers",
						link: "/nyt-games/",
					},
				],
			},
		],
	},
	{
		label: "Word Games <span class='sub-label'>Helpers</span>",
		link: null,
		title: "Word Games Helpers",
		icon: "helpers",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Word Tools",
				sectionEntries: [
					{
						label: "Word Unscrambler",
						link: "/unscramble/",
					},
					{
						label: "Anagram Solver",
						link: "/anagram-solver/",
					},
					{
						label: "Word Scramble",
						link: "/word-scramble/",
					},
					{
						label: "Word Maker",
						link: "/word-maker/",
					},
					{
						label: "Random Word Generator",
						link: "/random-word-generator/",
					},
					{
						label: "Words with Letters and a Blank",
						link: "/words-with-letters-blank/",
					},
					{
						label: "Word Solver",
						link: "/word-solver/",
					},
				],
			},
			{
				sectionName: "Daily Word Games",
				sectionEntries: [
					{
						label: "Crossword Solver",
						link: "/crosswords/",
					},
					{
						label: "Quordle Solver",
						link: "/quordle/",
					},
					{
						label: "Today's Contexto Answer",
						link: "/contexto/",
					},
					{
						label: "Parseword Hints & Answer",
						link: "/parseword/",
						isNew: true,
					},
				],
			},
			{
				sectionName: "Popular Games",
				sectionEntries: [
					{
						label: "4 Pics 1 Word Answers",
						link: "/4pics1word/",
					},
					{
						label: "Jumble Solver",
						link: "/jumble-solver/",
					},
					{
						label: "Word Wars Cheat",
						link: "/word-wars/",
					},
					{
						label: "Word Connect Answers",
						link: "/word-connect-answers/",
					},
					{
						label: "Word Chums Cheat",
						link: "/word-chums-cheat/",
					},
					{
						label: "Word Cookies! Cheat",
						link: "/word-cookies/",
					},
					{
						label: "All Word Games Helpers",
						link: "/game-cheats/",
					},
				],
			},
		],
	},
	{
		label: "Word List <span class='sub-label'>Maker</span>",
		link: null,
		title: "Word List Maker",
		icon: "list",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		submenu: [
			{
				sectionName: "Top Word Lists",
				sectionEntries: [
					{
						label: "Words that Contain",
						link: "/words-with-the-letter/",
					},
					{
						label: "Words by Length",
						link: "/letter-words/",
					},
					{
						label: "Words that Start With",
						link: "/words-that-start/",
					},
					{
						label: "Words Ending In",
						link: "/ending-with/",
					},
					{
						label: "Words without Vowels",
						link: "/consonants/",
					},
					{
						label: "Q Words without U",
						link: "/q-no-u/",
					},
					{
						label: "Popular Word Combos",
						link: "/popular-pages/",
					},
					{
						label: "Top Searched Word Combos",
						link: "/top-searched-word-combos/",
					},
					{
						label: "Top Unscrambles",
						link: "/top-unscrambles/",
					},
				],
			},
			{
				sectionName: "5 Letter Words",
				sectionEntries: [
					{
						label: "5 Letter Words",
						link: "/letter-words/5/",
					},
					{
						label: "5 Letter Word Finder",
						link: "/5-letter-word-finder/",
					},
					{
						label: "5 Letter Words That Start With",
						link: "/5-letter-words-start/",
					},
					{
						label: "5 Letter Words That End In",
						link: "/5-letter-words-end/",
					},
					{
						label: "5 Letter Words That Contain",
						link: "/5-letter-words-with/",
					},
					{
						label: "5-Letter Word Lists",
						link: "/5-letter-word-lists/",
					},
				],
			},
			{
				sectionName: "Word Lists by Length",
				sectionEntries: [
					{
						label: "3 Letter Words",
						link: "/letter-words/3/",
					},
					{
						label: "4 Letter Words",
						link: "/letter-words/4/",
					},
					{
						label: "6 Letter Words",
						link: "/letter-words/6/",
					},
					{
						label: "7 Letter Words",
						link: "/letter-words/7/",
					},
					{
						label: "8 Letter Words",
						link: "/letter-words/8/",
					},
					{
						label: "9 Letter Words",
						link: "/letter-words/9/",
					},
				],
			},
			{
				sectionName: "Word List Finders",
				sectionEntries: [
					{
						label: "4 Letter Word Finder",
						link: "/4-letter-word-finder/",
					},
					{
						label: "6 Letter Word Finder",
						link: "/6-letter-word-finder/",
					},
					{
						label: "7 Letter Word Finder",
						link: "/7-letter-word-finder/",
					},
					{
						label: "8 Letter Word Finder",
						link: "/8-letter-word-finder/",
					},
					{
						label: "All Word Lists",
						link: "/index/",
					},
				],
			},
		],
	},
	{
		label: "Blog",
		link: "/blog/",
		icon: "blog",
		isNew: false,
		mobileOnly: true,
		useRouter: true,
	},
	{
		label: "Our Brands",
		link: null,
		icon: "brands",
		cssClass: "has-hint",
		navLink: true,
		submenuIsOpen: false,
		mobileOnly: true,
		otherSites: true,
		submenu: [
			{
				sectionEntries: [
					{
						label: "Wordscapes Answers & Cheat",
						logo: "/static/images/ic_ft_ws.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://wordscapes.yourdictionary.com",
					},
					{
						label: "Crossword Helper",
						logo: "/static/images/ic_ft_cwh.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://crosswordhelper.com/",
					},
					{
						label: "WordList Finder",
						logo: "/static/images/ic_ft_wlf.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://wordlistfinder.com/",
					},
					{
						label: "Simply Scrabble",
						logo: "/static/images/ic_ft_sis.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://simplyscrabble.com/",
					},
					{
						label: "Buscador de Palabras",
						logo: "/static/images/ic_wfw_header.png",
						logoWidth: 32,
						logoHeight: 20,
						link: "https://es.yourdictionary.com/buscador-de-palabras/",
					},
					{
						label: "YourDictionary",
						logo: "/static/images/ic_ft_yd.png",
						logoWidth: 26,
						logoHeight: 26,
						link: "https://www.yourdictionary.com/",
					},
				],
			},
		],
	},
];
